module.exports = __webpack_public_path__ + "static/ubicacion-36b503f114fc120b698e0de43ef536a3.png";